<template>
<div class="chapter">
<div class="inner_page">
<div class="generated-style-2" id="hrye01">
<p class="part-number" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span class="no-style-override-9">PART I: ORIGINS</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?84e89e02